import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BalanceQuery,
  BalanceService,
  CardTokenService,
  config,
  MemberCard,
  MemberCardQuery,
  MemberDetails,
  MemberQuery,
  UserContext,
} from '@fgb/core';

@Component({
  selector: 'fgb-account-identity-header',
  templateUrl: './account-identity-header.component.html',
  styleUrls: ['./account-identity-header.component.scss'],
})
export class AccountIdentityHeaderComponent implements OnInit {
  member$: Observable<MemberDetails | undefined>;
  memberCard$: Observable<MemberCard | undefined>;
  userContext$: Observable<UserContext | undefined>;
  points$: Observable<number | undefined>;
  credit$: Observable<number | undefined>;

  constructor(
    private memberQuery: MemberQuery,
    private memberCardQuery: MemberCardQuery,
    private balanceQuery: BalanceQuery,
    private balanceService: BalanceService,
    private cardTokenService: CardTokenService
  ) {}

  ngOnInit() {
    this.member$ = this.memberQuery.selectMemberDetails();
    this.memberCard$ = this.memberCardQuery.selectCurrentCard();
    this.userContext$ = this.memberQuery.userContext$;
    this.points$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.credit$ = this.balanceQuery.selectPurse(config.purseConfig.combined);

    this.balanceService.fetchBalance(config.purseConfig.virtualLoyalty).toPromise();
    this.balanceService.fetchBalance(config.purseConfig.combined).toPromise();
    this.cardTokenService.fetchDefaultCardToken().toPromise();
  }

  /** DiscountLevel/RetailDiscountLevel come back as bare numbers (e.g. "20"), not "20%". */
  formatDiscount(value: string | undefined): string {
    if (!value) {
      return '';
    }

    return value.trim().endsWith('%') ? value : `${value}%`;
  }
}
